/**
 * Google OAuth sign-in. Fetches the start-URL from our backend (which
 * Stytch generates with the right redirect_uri) and redirects the
 * browser to it. The callback comes back to the app via Stytch's
 * authenticate endpoint, which our backend translates into a session
 * cookie.
 *
 * Plain async function — no React lifecycle. Call it from a click
 * handler.
 *
 *   <button onClick={startGoogleSignIn}>Sign in with Google</button>
 *
 * The browser is going to navigate away on success, so there's no
 * "post-success" state to manage in React.
 */
import { get } from "../api/client";

export async function startGoogleSignIn(): Promise<void> {
  try {
    const { url } = await get<{ url: string }>("/stytch/google-oauth-url");
    window.location.href = url;
  } catch (err) {
    console.error("Failed to start Google sign-in:", err);
    throw err;
  }
}
